export const fixAutocomplete = () => {
    document.querySelectorAll('.ant-select-selector input').forEach((e) => {
        e.setAttribute('autocomplete', 'stopDamnAutocomplete');
        //you can put any value but NOT "off" or "false" because they DO NOT works
    });
};

export const fixSelectOnScroll = (triggerNode: HTMLElement) => triggerNode.parentNode as HTMLElement;
